// utils/statFormatters.js
export const formatAgeGroups = (arr, limit = 5) => {
    if (!Array.isArray(arr) || arr.length === 0) return 'N/A';
  
    return arr
      .slice(0, limit)
      .map(item => item.name.replace(/_/g, '-'))
      .join(', ');
  };
  